import React, { useState } from "react";
import SearchBar from "./components/SearchBar";
import SearchResults from "./components/SearchResults";
import "./App.css";

const App = () => {
  const [results, setResults] = useState([]);
  const [darkMode, setDarkMode] = useState(false);

  const toggleDarkMode = () => {
    setDarkMode((prev) => !prev);
  };

  return (
    <div className={darkMode ? "app dark-mode" : "app"}>
      <header className="header">
        <div className="title-wrapper">
          <h1 className="app-title">How Can i Assist Today?</h1>
        </div>
        <button className="dark-mode-toggle" onClick={toggleDarkMode}>
          {darkMode ? "🌙 " : "☀️"}
        </button>
      </header>
      <SearchBar setResults={setResults} />
      <SearchResults results={results} />
    </div>
  );
};

export default App;
